import React, { useState, useEffect } from 'react'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { string } from 'prop-types'
const ContactForm = props => {
    const [isError, setError] = useState(false)
    const [isSend, setSend] = useState(false)
    const [field, setFieldValue] = useState({
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        message: '',
    })
    const [errors, setErrorText] = useState({
        firstName: '',
        lastName: '',
        company: '',
        email: '',
        message: '',
    })
    useEffect(() => {
        if (isError === false && isSend) {
            const response = fetch(
                `https://api.prosperworks.com/developer_api/v1/leads`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-PW-Application': 'developer_api',
                        'X-PW-AccessToken': 'af8cb93c26513951d397a327883571c8',
                        'X-PW-UserEmail': '',
                    },
                    body: JSON.stringify({
                        name: ' ',
                        email: {
                            email: 'mylead@noemail.com',
                            category: 'work',
                        },
                        phone_numbers: [
                            {
                                number: '415-123-4567',
                                category: 'mobile',
                            },
                        ],
                    }),
                }
            )
            setIsSuccessSend(true)
            setSend(false)
        }
        console.log(isError)
        console.log(isSend)
    })
    const [isSuccessSend, setIsSuccessSend] = useState(false)
    const inputHandler = e => {
        let objectCopy = Object.assign({}, field)
        objectCopy[e.target.name] = e.target.value
        setFieldValue(objectCopy)
        let errorsCopy = Object.assign({}, errors)
        errorsCopy[e.target.name] = ''
        setErrorText(errorsCopy)
    }
    const submitHandler = e => {
        e.preventDefault()
        setError(false)
        let errorsCopy = Object.assign({}, errors)
        for (const key in field) {
            if (props[key]) {
                if (field[key] === '') {
                    errorsCopy[key] = 'Fill this field, please.'
                    setError(true)
                } else {
                    errorsCopy[key] = ''
                }
            }
        }
        setErrorText(errorsCopy)
        if (props.email) {
            if (
                !field.email.match(
                    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
                ) &&
                field.email !== ''
            ) {
                setError(true)
                errorsCopy[email] = 'Your email is not valid!'
            }
            setErrorText(errorsCopy)
        }
        setSend(true)
    }
    return (
        <form action="#" method="post" onSubmit={e => submitHandler(e)}>
            {isSuccessSend ? (
                <div className="form__success">
                    <h2>THANKS! WE'LL BE IN TOUCH.</h2>
                </div>
            ) : (
                <div>
                    {props.firstName ? (
                        <>
                            {errors.firstName !== '' ? (
                                <span className="contact-us-input-error">
                                    {errors.firstName}
                                </span>
                            ) : null}
                            <input
                                type="text"
                                name="firstName"
                                placeholder={
                                    typeof props.firstName === 'string'
                                        ? props.firstName
                                        : 'First name'
                                }
                                onChange={e => inputHandler(e)}
                                className={
                                    errors.firstName !== '' ? 'error' : null
                                }
                            />
                        </>
                    ) : null}
                    {props.lastName ? (
                        <>
                            {errors.lastName !== '' ? (
                                <span className="contact-us-input-error">
                                    {errors.lastName}
                                </span>
                            ) : null}
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Last name"
                                onChange={e => inputHandler(e)}
                                className={
                                    errors.lastName !== '' ? 'error' : null
                                }
                            />
                        </>
                    ) : null}
                    {props.company ? (
                        <>
                            {errors.company !== '' ? (
                                <span className="contact-us-input-error">
                                    {errors.company}
                                </span>
                            ) : null}
                            <input
                                type="text"
                                name="company"
                                placeholder="Company"
                                onChange={e => inputHandler(e)}
                                className={
                                    errors.company !== '' ? 'error' : null
                                }
                            />
                        </>
                    ) : null}
                    {props.email ? (
                        <>
                            {errors.email !== '' ? (
                                <span className="contact-us-input-error">
                                    {errors.email}
                                </span>
                            ) : null}
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                onChange={e => inputHandler(e)}
                                className={errors.email !== '' ? 'error' : null}
                            />
                        </>
                    ) : null}
                    {props.message ? (
                        <>
                            {errors.message !== '' ? (
                                <span className="contact-us-input-error">
                                    {errors.message}
                                </span>
                            ) : null}
                            <textarea
                                name="message"
                                id="message"
                                placeholder="Message"
                                onChange={e => inputHandler(e)}
                                className={
                                    errors.message !== '' ? 'error' : null
                                }
                            />
                        </>
                    ) : null}
                    <button className="contact-us__btn" type="submit">
                        Speak With A Growth Specialist
                    </button>
                </div>
            )}
        </form>
    )
}

export default ContactForm
